import axios from "axios"
import { history } from "../../../history"
import API from '../../../services/api'

  // Get Master Data
export const getAllMasterData = (parms) => {
  return async dispatch => {
  API({
      url: 'master/all-data',
      method: 'POST'
    }).then(response => {
        dispatch({ type: "SET_ALL_MASTER_DATA", data: response.data })
    })
}}